import { createSelector } from 'reselect';
import { MgState, UserEntityInterface } from '@types';
import _isEmpty from 'lodash/isEmpty';

const getUser = (store: MgState): UserEntityInterface => store?.user?.currentUser;

export const isUserSelector = createSelector(
  [getUser],
  (user): boolean => _isEmpty(user?.roles) && _isEmpty(user?.unit?.roles)
);
